// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPrice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.28 14.571H4.01a7.988 7.988 0 1 1 15.978 0h-1.851"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.874 17.486a2.77 2.77 0 0 0 2.057.925c.788 0 1.234-.308 1.234-.823 0-.582-.686-.754-1.474-.96-.96-.205-2.229-.582-2.229-2.022 0-1.029.755-1.783 1.92-2.023v-.412c0-.514.172-.754.617-.754h.069c.446 0 .617.24.617.754v.377c1.2.138 1.886.686 1.886 1.235a.95.95 0 0 1-.583.788 2.53 2.53 0 0 0-1.851-.822c-.72 0-1.166.342-1.166.822 0 .583.583.72 1.44.892.994.206 2.331.617 2.331 2.057 0 1.097-.754 1.851-2.023 2.057v.411c0 .515-.205.755-.617.755h-.068c-.446 0-.617-.24-.617-.754v-.412c-1.303-.137-2.058-.754-2.058-1.337-.068-.48.48-.823.515-.754zM12 3.291v2.023M6.343 4.8 7.37 6.548M2.229 8.914l1.748 1.029M2.743 14.571H.72M23.314 14.571h-2.057M21.771 8.914l-1.748 1.029M17.657 4.8l-1.03 1.748"
    />
  </svg>
);
export default SvgPrice;
